// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"390":"498f7702","486":"d42554f9"}[chunkId] + ".chunk.css";
};